import React from 'react';
import { useSelector } from 'react-redux';

import loadingIcon from 'assets/loading_light_green.svg';

import 'style/layout/Spinner.css';

const Spinner = (): JSX.Element | null => {
  const loading = useSelector((state: any) => state.loading);

  if (loading.length === 0) {
    return null;
  }

  return (
    <div className="layout-spinner-layover">
      <div className="layout-spinner">
        <img alt="" src={loadingIcon} />
      </div>
    </div>
  );
};

export default Spinner;
